<div class="d-flex justify-content-between">
    <h2 mat-dialog-title>Upload Document</h2>
    <button color="primary" mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content *ngIf="!uploadSuccess">
    <form [formGroup]="uploadDocumentForm" class="inputs-container">
        <mat-form-field appearance="outline">
            <mat-label>Document Name</mat-label>
            <input type="text" matInput formControlName="document_name" placeholder="Document Name">
            <mat-error *ngIf="isFieldHasRequiredError('document_name')">Document name is
                required</mat-error>
        </mat-form-field>

        <app-tags-autocomplete [tags]="allAvailableTags" [defaultTags]="defaultTags"
            [config]="data.options.tagsAutocompleteOptions"
            (change)="onSelectedTagsChanged($event)"></app-tags-autocomplete>

        <mat-form-field appearance="outline" *ngIf="this.data.options.showExpiryDateColumn">
            <mat-label>Expiry Date</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="expiry_date">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2 color="primary"></mat-datepicker>
        </mat-form-field>

        <div class="mm-mt-3">
            <div *ngIf="!uploadDocumentForm.get('document').value; else showFileName;">
                <button mat-stroked-button color="primary" (click)="document.click()" class="upload-file-btn">
                    <div class="label">
                        <span> Select File</span>
                        <mat-icon>description</mat-icon>
                    </div>
                </button>
                <div class="mm-text-center mm-mt-2"><b>Note:</b> Maximum file size 10MB</div>
                <input type="file" #document accept="application/pdf,image/*" style="display:none;" id="file-upload"
                    (change)="uploadFile($event)">
            </div>
            <ng-template #showFileName>
                <div class="uploaded-file">
                    <span>{{ uploadDocumentForm.get('document').value?.name }}</span>
                    <button mat-icon-button (click)="resetFile()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div>
            </ng-template>
            <mat-error *ngIf="isFieldHasRequiredError('document')">Please select a file</mat-error>
        </div>


    </form>
</mat-dialog-content>

<mat-dialog-content *ngIf="uploadSuccess" class="mm-text-center mm-my-4">
    <div class="success-container">
        <h3 class="success-title">
            <mat-icon class="success-icon">check_circle</mat-icon>
            Document uploaded successfully
        </h3>
        <p class="success-message">You can upload another document if needed.</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mm-mt-5 mm-mb-3" *ngIf="!uploadSuccess">
    <button mat-flat-button color="primary" [disabled]="uploadDocumentForm.invalid || loading" class="upload-btn"
        (click)="uploadDocument()"> <span *ngIf="!loading">Upload</span>
        <span *ngIf="loading">Uploading, please wait...</span>
    </button>
</mat-dialog-actions>

<mat-dialog-actions align="center" class="mm-mt-5 mm-mb-3" *ngIf="uploadSuccess">
    <button mat-flat-button color="primary" (click)="resetFormForNextUpload()">Upload Another Document</button>
    <button mat-stroked-button color="warn" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>